export default {"src":"/_next/static/media/backgroundClosedDocEnVille75.9ec07294.svg","height":167,"width":464,"blurWidth":0,"blurHeight":0};